/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Help_TextInputs */



/**
* | output |
* | --- |
* | "Trouble signing in?" |
*
* @param {Portalsignin_Help_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_help_text = /** @type {((inputs?: Portalsignin_Help_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Help_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Trouble signing in?")
});